import { TUTORIALS_PLACEMENT } from '@lootboy/lib/constants';

import { ITutorial } from '~/interfaces/ITutorial';
import {
  CARDS_PATH,
  COMICS_PATH,
  DIAMONDS_PATH,
  JOBS_PATH,
  PACKS_PATH,
  TUTORIAL_PATH_CREATOR,
} from '~/routes/paths';

const tutorialPath: {
  [key: string]: string;
} = {
  [TUTORIALS_PLACEMENT.HOME]: PACKS_PATH,
  [TUTORIALS_PLACEMENT.DIAMONDS]: DIAMONDS_PATH,
  [TUTORIALS_PLACEMENT.INVENTORY]: CARDS_PATH,
  [TUTORIALS_PLACEMENT.COMICS]: COMICS_PATH,
  [TUTORIALS_PLACEMENT.JOBS]: JOBS_PATH,
};

export function getTutorialPaths({
  placement,
  _id,
}: ITutorial): null | { route: string; path: string } {
  const route = tutorialPath[placement];
  const path = TUTORIAL_PATH_CREATOR(_id);
  if (!path) {
    return null;
  }
  return { route, path };
}
